<template>
   <div class="ZCode">
        <codemirror
            style="height:100%"
            v-model="computedVal"
            :options="option"
            @ready="ready"
            @input="input"
            @changes="changes"
        ></codemirror>
   </div>
</template>

<script>
    import { JSHINT } from "jshint";

    import { codemirror } from "vue-codemirror";
    // 这里引入的模式的js，根据设置的mode引入
    import "codemirror/mode/javascript/javascript.js";
    // 光标行背景高亮，配置里面也需要styleActiveLine设置为true
    import "codemirror/addon/selection/active-line.js";
    import "codemirror/addon/edit/matchbrackets.js";

    // JavaScript代码提示功能需要引入三个依赖
    import "codemirror/addon/hint/javascript-hint.js";
    import "codemirror/addon/hint/show-hint.js";

    // 折叠
    import "codemirror/addon/fold/foldcode.js";
    import "codemirror/addon/fold/foldgutter.js";
    import "codemirror/addon/fold/brace-fold.js";
    import "codemirror/addon/fold/comment-fold.js";

    // 下面这几个引入的主要是验证提示类的,配置里的lint需要设置true,gutters: ['CodeMirror-lint-markers']
    // 如果需要验证 json 的话
    import "codemirror/addon/lint/lint.js";
    import "codemirror/addon/lint/javascript-lint.js";
    import "codemirror/addon/display/autorefresh"; // 及时自动更新，配置里面也需要设置autoRefresh为true

    export default {
        name: "ZCode",
        components: {
            codemirror
        },
        props: {
            value: String,
            option: {
                type: Object,
                default: function () {
                    return {
                        mode: "javascript",
                        theme: "cobalt",
                        dragDrop: true, // 拖拽
                        lineWrapping: true, // 换行
                        autofocus: true,
                        lineNumbers: true, // 行号
                        foldGutter: true, // 代码折叠
                        line: true,
                        matchBrackets: true, // 括号匹配
                        extraKeys: { Ctrl: "autocomplete" },
                        showCursorWhenSelecting: true, // 在选择时是否显示光标，默认为false
                        lineWiseCopyCut: true, // 启用时，如果在复制或剪切时没有选择文本，那么就会自动操作光标所在的整行]
                        autorefresh: true, // 及时自动更新
                        lint: true, // json检查
                        hint: true,
                        styleActiveLine: true,
                        gutters: [
                            "CodeMirror-linenumbers", // 显示行号
                            "CodeMirror-foldgutter", // 代码折叠
                            "CodeMirror-lint-markers" // json检查
                        ]
                    };
                }
            }
        },
        model: {
            prop: "value",
            event: "change"
        },
        data () {
            return {};
        },
        computed: {
            computedVal: {
                get () {
                    return this.value;
                },
                set (val) {
                    this.handleChange(val);
                }
            }
        },
        created () {
            window.JSHINT = JSHINT;
        },
        methods: {
            ready (cm) {
                cm.setSize("100%", "100%");
                this.$emit("ready", cm);
            },
            input (cm) {
                this.$emit("input", cm);
            },
            changes (cm, value) {
                this.$emit("changes", cm, value);
            },
            handleChange (val) {
                // 0 no, 1 warning 2 error
                JSHINT(val);
                let errors = (JSHINT.data().errors || [])
                    .map(error => error.code ? (error.code.startsWith("W") ? 1 : 2) : 2);

                this.$emit("jshint", errors.some(errorNum => errorNum === 2), errors);
                this.$emit("change", val);
            }
        }
    };
</script>

<style lang="less" scoped>
   .ZCode {
       width: 100%;
       height: 100%;
   }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/other/ZCode.vue